<template>
	<div>
		<div class="product__properties props" v-if="hasPrice">

			<div class="props__item">
				<div class="props__title">Объем / вес:</div>
				<select class="uk-select" @change="setCurrentProp" v-if="!item.price">
					<option v-for="u, i in item.props" :value="i">{{ u.vol }} {{ u.unit == 'литр' ? 'мл' : u.unit }}</option>
				</select>
				<div class="uk-text-center" v-else>1 {{ item.props[currentProp].unit }}</div>
			</div>

			<div class="props__item">
				<div class="props__title">Количество:</div>
				<div class="props__count">
					<button uk-icon="minus" @click="minus"></button>
					<strong>{{ count }}</strong>
					<button uk-icon="plus" @click="plus"></button>
				</div>
			</div>

			<div class="props__item">
				<div class="props__title">Цена:</div>
				<div class="props__price">{{ item.props[currentProp].price | cifer }} ₽</div>
			</div>

			<div class="props__item">
				<div class="props__title">Сумма:</div>
				<div class="props__sum">{{ item.props[currentProp].price * count | cifer }} ₽</div>
			</div>

		</div>
		<div class="product__attent" v-if="!hasPrice">Скоро в продаже</div>
		<!--<button @click="checkCart">Проверить корзину</button>
		<button @click="clearCart">Очистить корзину</button>-->
		<button class="product__addtocart" @click="addToCart" v-if="hasPrice">
			<img :src="url + '/assets/img/ico-cartprod.svg'" alt="">
			<span>ДОБАВИТЬ В КОРЗИНУ</span>
		</button>
	</div>
</template>

<script>
  import { bus } from './bus.js'
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import { product } from "../mixins/product";
  export default {
    name: "product-component",
    data() {
      return {
        count: 1,
        currentProp: 0
      }
    },
    props: {
      url: '',
      item: ''
    },
    mixins: [product],
    computed: {},
    methods: {
      setCurrentProp(event) {
        this.currentProp = event.target.value;
      },
      plus() {
        this.count++;
      },
      minus() {
        if (this.count > 1) {
          this.count--;
        }
      },
	    checkCart(){
        $.request('onCheckCart', {
          data: '',
          success: function (data) {
            //... do something ...
            console.log(data);
            //this.success(data);
          },
          error: function (err) {
            console.log(err);
          }
        })
	    },
      clearCart(){
        $.request('onClearCart', {
          data: '',
          success: function (data) {
            //... do something ...
            console.log(data);
            //this.success(data);
          },
          error: function (err) {
            console.log(err);
          }
        })
      },
      addToCart() {
        let item = this.item;
        let currentProp = this.item.props[this.currentProp];
				let count = this.count;
				let total = currentProp.price * count;

				item.currentProp = currentProp;
				item.count = count;
				item.total = total;

				//delete item.category;
				//delete item.props;
				//delete item.prop_id;
				//delete item.price;

        this.sendForm(item);
				this.notify();
      },
      sendForm(item) {
        let fd = {
          item
        };

        console.log(fd);
        $.request('onAddtoCart', {
          data: fd,
          success: function (data) {
            //... do something ...
            //console.log(data);
            bus.$emit('cart-reload', data.cart);
            //this.success(data);
          },
          error: function (err) {
            console.log(err);
          }
        })
      }
    },
	  mounted(){

	  },
    created() {
      this.checkHasPrice();
      if(this.hasPrice){
        if(this.checkPrice()){
          this.item.props = [];
          this.item.props[0] = this.checkPrice();
        }
      }

    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// themes/polza/src/js/components/commerce/product.vue